export enum AccommodationType {
  TemporaryRent = '2',
}
